$(function () {
    // 商品削除
    $('.order_item_delete_btn').click(function() {
        let $form = $('#cart_delete_item_form');
        let warehouse_code = $(this).attr('warehouse_code');
        let item_code = $(this).attr('item_code') + '_' + $(this).attr('item_branch');
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: {'warehouse_code': warehouse_code, 'item_code': item_code},
            dataType: 'json'
        }).done(function (data) {
            let $form = $('#cart_change_form');
            $form.submit();
        }).fail(function (data) {
            // TODO: エラー時制御
        });
    });

    // 商品数量変更
    $('.item_quantity').change(function() {
        let $form = $('#cart_change_quantity_form');
        let warehouse_code = $(this).attr('warehouse_code');
        let item_code = $(this).attr('item_code') + '_' + $(this).attr('item_branch');
        let item_quantity = $(this).val();
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: {'item_quantity': item_quantity, 'warehouse_code': warehouse_code, 'item_code': item_code},
            dataType: 'json'
        }).done(function (data) {
            let $form = $('#cart_change_form');
            $form.submit();
        }).fail(function (data) {
            // TODO: エラー時制御
        });
    });

    // 配送先国変更
    $('#select_country_code').change(function() {
        $('.delivery_method').prop('disabled', true);
        np_jp.lock();
        let $form = $('#cart_change_form');
        $form.submit();
    });

    // 配送方法変更
    $('.delivery_method').change(function() {
        np_jp.lock();
        $('.delivery_method').val($(this).val());
        let $form = $('#cart_change_form');
        $form.submit();
    });

    $('.medical-dialog-open').click(function () {
        let item_prefix = $(this).data('dialog-prefix');
        let item_code = $(this).data('dialog-code');
        let item_branch = $(this).data('dialog-branch');

        let url = location.origin
            + '/item/detail?item_prefix=' + item_prefix
            + '&item_code=' + item_code
            + '&item_branch=' + item_branch;

        let medical_flg = $(this).data('dialog-medical-flg');
        if (medical_flg !== 1) {
            // 医療従事者向け以外⇒商品詳細に遷移
            window.location.href = url;

        } else {
            // 医療従事者向け⇒ダイアログの「はい」ボタンのhrefを書き換える
            let link = document.getElementById('item-detail-link');
            link.setAttribute('href', url);

            // ダイアログを開く
            let dialog_target = $(this).data('dialog-target');
            common.openDialog(dialog_target)
        }
    });

    // ダイアログを開く
    let dialog_target = $('.unset-items-open').data('dialog-target');
    common.openDialog(dialog_target);

    // ダイアログを閉じる
    $('.dialog-close-btn').click(function () {
        common.closeDialog()
    });
});
